import React from "react";
import { inject, observer } from "mobx-react";
import { LanguageStore } from "src/stores";
import { Helmet } from "react-helmet";

interface SkypeButtonProps {
  url: string;
  languageStore?: LanguageStore;
}

export const SkypeButton = inject("languageStore")(
  observer(({ url, languageStore }: SkypeButtonProps) => {
    const skypeHasLoaded =
      typeof window !== "undefined" &&
      typeof (window as any).Skype !== "undefined";

    React.useEffect(() => {
      if (skypeHasLoaded)
        (window as any).Skype.initialize(
          { apiKey: "shareButton" },
          function() {},
          function() {}
        );
    }, []);

    return (
      <>
        {!skypeHasLoaded && (
          <Helmet>
            <script>
              {(function(r: any, d: any, s: any): any {
                r.loadSkypeWebSdkAsync =
                  r.loadSkypeWebSdkAsync ||
                  function(p) {
                    var js,
                      sjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(p.id)) {
                      return;
                    }
                    js = d.createElement(s);
                    js.id = p.id;
                    js.src = p.scriptToLoad;
                    js.onload = p.callback;
                    sjs.parentNode.insertBefore(js, sjs);
                  };
                var p = {
                  scriptToLoad:
                    "https://swx.cdn.skype.com/shared/v/latest/skypewebsdk.js",
                  id: "skype_web_sdk",
                };
                r.loadSkypeWebSdkAsync(p);
              })(window, document, "script")}
            </script>
          </Helmet>
        )}
        <div
          className="skype-share"
          data-href={url}
          data-lang={convertToSkypeLang(languageStore?.currentLanguage?.locale)}
          data-style="circle"
          data-source="WordPress"
        ></div>
        <div style={{ clear: "both", paddingBottom: "10px" }}></div>
      </>
    );
  })
);

const convertToSkypeLang = (locale: string) => {
  if (typeof locale !== "string") return "en-us";

  return locale?.toLocaleLowerCase()?.replaceAll("_", "-");
};
